import React, { FC } from "react";

import {
  convertParentToOptions,
  convertOptionToParent,
  convertParentToOption,
} from "./CommonFunctions";
import { ParentWithChildDropdownField } from "./ParentWithChildDropdownField";

import {
  ParentType,
  ChildType,
  OptionType,
  DropDownOnChangeType,
} from "~/domains";

import { LabelWithDropDownField } from "~/ui";

type PropsType = {
  selectableDropdownDivisions: ParentType[];
  selectedDropdownDivision?: ParentType | null;
  selectableDropdownSections: ChildType[];
  selectedDropdownSection?: ChildType | null;
  selectableDropdownEmployees?: ParentType[];
  selectedDropdownEmployee?: ParentType;
  onDivisionChange: (value: ParentType | null) => void;
  onSectionChange: (value: ChildType | null) => void;
  onEmployeeChange: (value: ParentType | undefined) => void;
};

export const DivisionAndSectionAndEmployeeDropdownField: FC<PropsType> = ({
  selectableDropdownDivisions,
  selectedDropdownDivision,
  selectableDropdownSections,
  selectedDropdownSection,
  selectableDropdownEmployees,
  selectedDropdownEmployee,
  onDivisionChange,
  onSectionChange,
  onEmployeeChange,
}: PropsType) => {
  return (
    <>
      <ParentWithChildDropdownField
        allParents={selectableDropdownDivisions}
        parentValue={selectedDropdownDivision}
        parentLabel="部署"
        parentsOnChange={onDivisionChange}
        allChildren={selectableDropdownSections}
        childValue={selectedDropdownSection}
        childLabel="課"
        childrenOnChange={onSectionChange}
      />
      <LabelWithDropDownField
        required={false}
        labelText="ユーザー"
        name="employees"
        options={convertParentToOptions(selectableDropdownEmployees || [])}
        value={
          selectedDropdownEmployee
            ? convertParentToOption(selectedDropdownEmployee)
            : undefined
        }
        onChange={(newValue: DropDownOnChangeType<OptionType>) => {
          onEmployeeChange(
            newValue
              ? convertOptionToParent(newValue as OptionType)
              : undefined,
          );
        }}
      />
    </>
  );
};
